import { assertNever } from '../../../../../Decoders';
import { emptyFragment } from '../../../../../EmptyFragment';
import { T } from '../../../../../Translations';
import { usePreviewLicense } from './PreviewLicenseContext';

// DVLP-7601: "9 of 12 courses unlocked" beside the license dropdown — the
// numbers are emphasized, the words are not. Reads from the selected option
// so it stays correct while the locked cards are hidden; nothing renders
// until the options have loaded and a license is selected.

function UnlockedCount() {
  const { selectedOption, optionsState } = usePreviewLicense();

  switch (optionsState.kind) {
    case 'loading':
    case 'errored':
      return null;
    case 'ready':
      return selectedOption
        .map((o) => (
          <span key="count" data-intercom-target="preview-unlocked-count">
            <T
              kind="<span>{{unlocked}}</span> of <span>{{total}}</span> courses unlocked"
              span={(content) => (
                <span style={{ fontWeight: 'var(--font-weight-semibold)' }}>{content}</span>
              )}
              unlocked={o.unlocks_count}
              total={o.total_count}
            />
          </span>
        ))
        .getOrElse(emptyFragment);
  }
  return assertNever(optionsState);
}

export default UnlockedCount;
